module.exports = __webpack_public_path__ + "assets/img/turkiyefinans@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/turkiyefinans@2x.png
// module id = 142
// module chunks = 0